export const Uri = {
  action: {
    execute: 'actions/execute',
  },
  authentication: {
    createSessions: 'sessions/create',
    logout: 'auth/logout',
    logoutDatastream: 'sessions/invalidate',
    permission: 'auth/permission',
    sessionValidate: 'sessions/validate',
    validateSessions: 'auth/validate',
  },
  billing: {
    triggerBillingReport: 'billing/run/report',
  },
  blueprint: {
    byId: 'blueprint/{0}',
    getPaged: 'blueprint',
  },
  calendar: {
    export: 'calendar/export',
    exportExternal: 'calendar/export/external',
    getData: 'calendar/counts',
    getDataExternal: 'calendar/counts/external',
    getMailingCalendar: 'calendar',
    getMailingCalendarExternal: 'calendar/external',
  },
  departments: {
    base: 'departments',
    byUid: 'departments/{0}',
    roleByUid: 'departments/{0}/roles/{1}',
    roles: 'departments/{0}/roles',
  },
  files: {
    externalLol: 'files/external',
    recipientTemplateFiles: 'files/recipient/template/{0}',
    suppressions: 'files/mailing-suppressions',
    template: 'files/template',
  },
  lookup: {
    agency: 'lookup/agency',
    client: 'lookup/client',
    customer: 'lookup/customer',
    districts: 'lookup/district',
    fileTypes: 'lookup/file-type',
    states: 'lookup/state',
  },
  mailing: {
    create: 'mailing',
    deleteMailing: 'mailing/{0}',
    deleteMailingComment: 'mailing/{0}/comment/{1}',
    deleteMailingTag: 'mailing/{0}/tags/{1}',
    getComments: 'mailing/{0}/comment',
    getDataProcessors: 'mailing/data-processors',
    getExternalMailingsByDeadline: 'mailing/external/by-deadline',
    getMailingConfig: 'mailing/{0}/config',
    getMailingDupeGroups: 'mailing/{0}/dupe-groups',
    getMailingListDupeGroup: 'mailing/{0}/list/dupe-groups',
    getMailingListsSummary: 'mailing/{0}/lists/summary',
    getMailingsByDeadline: 'mailing/by-deadline',
    getMailingSettings: 'mailing/{0}/settings',
    getMissingMailings: 'mailing/missing',
    getOmits: 'mailing/{0}/omits',
    getPaged: 'mailing',
    getPagedExternal: 'mailing/external',
    getPagedExternalMailingList: 'mailing/{0}/external/lists',
    getPagedMailingLists: 'mailing/{0}/lists',
    getScoringSummary: 'mailing/{0}/scoring',
    getTags: 'mailing/{0}/tags',
    insertMailingComment: 'mailing/{0}/comment',
    recency: 'mailing/{0}/recency',
    revertById: 'mailing/{0}/revert',
    seeds: 'mailing/{0}/seeds',
    update: 'mailing/{0}',
    updateMailingComment: 'mailing/{0}/comment/{1}',
    upsertMailingConfig: 'mailing/{0}/config',
    upsertMailingOmits: 'mailing/{0}/omits',
    upsertTags: 'mailing/{0}/tags',
  },
  mailingList: {
    deleteMailingList: 'mailing-list/{0}',
    deleteMailingListComment: 'mailing-list/{0}/comment/{1}',
    deleteMailingListScoringTags: 'mailing-list/scoring',
    deleteMailingListTag: 'mailing-list/{0}/tags/{1}',
    getComments: 'mailing-list/{0}/comment',
    getMissingLists: 'mailing-list/missing',
    getPaged: 'mailing-list',
    getPagedExternal: 'mailing-list/external',
    getTags: 'mailing-list/{0}/tags',
    insertMailingListComment: 'mailing-list/{0}/comment',
    managers: 'mailing-list/manager',
    update: 'mailing-list/{0}',
    updateMailingListComment: 'mailing-list/{0}/comment/{1}',
    upsertTags: 'mailing-list/{0}/tags',
  },
  notifications: {
    base: 'notification',
    byId: 'notification/{0}',
    readAll: 'notification/read-all',
    readById: 'notification/{0}/read',
  },
  nth: {
    twentileCount: 'nth/twentile-count',
    update: 'nth/{0}',
  },
  permissions: {
    base: 'permissions',
    byUid: 'permissions/{0}',
  },
  preferences: {
    base: 'preferences',
  },
  recipient: {
    getFlags: 'recipient/flags',
    getPaged: 'recipient',
    getPagedPreview: 'recipient/preview',
  },
  reports: {
    mergePurge: {
      listCompanyBilling: 'reports/merge-purge/list-company-billing',
      mailingSummary: 'reports/merge-purge/mailing-summary',
      modelingByList: 'reports/merge-purge/modeling-by-list',
      multisBreakdown: 'reports/merge-purge/multis-breakdown',
      multisByGroup: 'reports/merge-purge/multis-by-group',
      multisByList: 'reports/merge-purge/multis-by-list',
      seedCount: 'reports/merge-purge/seed-count',
      seedCountByMailCode: 'reports/merge-purge/seed-count-by-mail-code',
      stateDistribution: 'reports/merge-purge/state-distribution',
      suppressionDetails: 'reports/merge-purge/suppression-details',
      suppressionFiles: 'reports/merge-purge/suppression-files',
      twentileCount: 'reports/merge-purge/twentile-count',
    },
  },
  roles: {
    base: 'roles',
    byUid: 'roles/{0}',
    permissionByUid: 'roles/{0}/permissions/{1}',
    permissions: 'roles/{0}/permissions',
    users: 'roles/{0}/users',
  },
  savedFilters: {
    base: 'saved-filters',
    byId: 'saved-filters/{0}',
    lastUsed: 'saved-filters/{0}/last-used',
    reorder: 'saved-filters/reorder',
  },
  status: {
    get: 'status',
    getById: 'status/{0}',
    withActions: 'status/{0}/actions',
  },
  tags: {
    getByCategoryName: 'tags',
    getTagCategories: 'tags/category',
  },
  template: {
    deleteTemplateBatchDetailById: 'template/{0}/detail/batch/{1}',
    deleteTemplateDetailById: 'template/{0}/detail/{1}',
    getPagedTemplateDetailsByName: 'template/details/{0}',
    getTemplateCategories: 'template/category',
    getTemplates: 'template',
    getTemplatesBy: 'template/{0}',
    getTemplateTypes: 'template/type',
    getTemplateWithBatches: 'template/{0}/batch',
    insertTemplate: 'template',
    insertTemplateCategory: 'template/category',
    insertTemplateDetail: 'template/detail',
    updateTemplate: 'template/{0}',
    updateTemplateCategory: 'template/category/{0}',
    updateTemplateDetail: 'template/detail/{0}',
  },
  tooltip: {
    get: 'tooltip',
    getByName: 'tooltip/{0}',
  },
  users: {
    base: 'users',
    byUid: 'users/{0}',
    permissionByUid: 'users/{0}/permissions/{1}',
    permissions: 'users/{0}/permissions',
    roleByUid: 'users/{0}/roles/{1}',
    roles: 'users/{0}/roles',
  },
} as const;
